module.exports = __webpack_public_path__ + "img/3.72ab5443.png";